import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ApplyVoucherError, applyVoucher } from '../../api/cart/apply-voucher';
import syncCartCache from './sync-cart-cache';

const useApplyVoucher = () => {
    const queryClient = useQueryClient();

    return useMutation<Cart, ApplyVoucherError, string>({
        mutationFn: (code: string) => applyVoucher(code),
        onSuccess: (cart) => syncCartCache(queryClient, cart)
    });
};

export default useApplyVoucher;
